import { Skeleton } from "@/components/ui/skeleton";
import { DashboardLayout } from "@/components/DashboardLayout";
import { useDashboardPremium } from "@/hooks/useDashboardPremium";
import {
  DashboardHeroSection,
  DashboardProjectionSection,
  DashboardDistributionSection,
  DashboardMetricsSection,
  DashboardAlertsSection
} from "@/components/dashboard";

export default function DashboardPage() {
  const dashboardData = useDashboardPremium();

  // Loading state
  if (dashboardData.isLoading) {
    return (
      <DashboardLayout title="Dashboard" subtitle="Centro de inteligência financeira">
        <div className="space-y-6">
          <div className="grid gap-4 lg:grid-cols-3">
            <Skeleton className="h-[280px] rounded-xl" />
            <Skeleton className="h-[280px] rounded-xl lg:col-span-2" />
          </div>
          <Skeleton className="h-[200px] rounded-xl" />
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton key={i} className="h-[120px] rounded-xl" />
            ))}
          </div>
          <div className="grid gap-4 lg:grid-cols-2">
            <Skeleton className="h-[280px] rounded-xl" />
            <Skeleton className="h-[280px] rounded-xl" />
          </div>
        </div>
      </DashboardLayout>
    );
  }

  // Dashboard completo - acesso garantido pelo ProtectedRoute
  return (
    <DashboardLayout title="Dashboard" subtitle="Centro de inteligência financeira">
      <div className="space-y-8">
        {/* HERO - Monthly Performance */}
        <DashboardHeroSection
          confirmedRevenue={dashboardData.confirmedRevenue}
          monthlyGoal={dashboardData.monthlyGoal}
          goalProgress={dashboardData.goalProgress}
          previousMonthRevenue={dashboardData.previousMonthRevenue}
          revenueGrowthPercent={dashboardData.revenueGrowthPercent}
          dailyRevenueChart={dashboardData.dailyRevenueChart}
        />

        {/* PROJECTION */}
        <DashboardProjectionSection
          confirmedRevenue={dashboardData.confirmedRevenue}
          expectedRevenue={dashboardData.expectedRevenue}
          futureRecurringRevenue={dashboardData.futureRecurringRevenue}
          projectedRevenue={dashboardData.projectedRevenue}
          dailyAverage={dashboardData.dailyAverage}
          daysRemaining={dashboardData.daysRemaining}
          isOnTrack={dashboardData.isOnTrack}
          projectionMessage={dashboardData.projectionMessage}
          monthlyGoal={dashboardData.monthlyGoal}
        />

        {/* PERFORMANCE METRICS */}
        <DashboardMetricsSection
          realHourlyRate={dashboardData.realHourlyRate}
          targetHourlyRate={dashboardData.targetHourlyRate}
          totalMonthHours={dashboardData.totalMonthHours}
          hoursGrowthPercent={dashboardData.hoursGrowthPercent}
          previousMonthHours={dashboardData.previousMonthHours}
          revenueGrowthPercent={dashboardData.revenueGrowthPercent}
        />

        {/* DISTRIBUTION */}
        <DashboardDistributionSection
          clientRevenues={dashboardData.clientRevenues}
          hoursSplit={dashboardData.hoursSplit}
        />

        {/* ALERTS & PROJECTS */}
        <DashboardAlertsSection
          alerts={dashboardData.alerts}
          activeProjects={dashboardData.activeProjects}
          upcomingDeadlines={dashboardData.upcomingDeadlines}
        />
      </div>
    </DashboardLayout>
  );
}
